/**
 *
 * MeetingButton
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

function MeetingButton(props) {
  const { meeting, message } = props;
  const { studentId, details } = meeting;
  const link = `/students/${studentId}/meetings/${details.set.id}`;
  return (
    <Button as={Link} variant="primary" to={link}>
      <FormattedMessage {...message} />
    </Button>
  );
}

MeetingButton.propTypes = {
  meeting: PropTypes.object,
  message: PropTypes.object,
};

export default MeetingButton;
